import { Button } from '@mui/material'
import React from 'react'

const ApplyToAll = ({ formMethods, disabled = false }: any) => {
  const setHours = () => {
    const value = formMethods.getValues('openingHours.monday')
    formMethods.setValue('openingHours.tuesday', value)
    formMethods.setValue('openingHours.wednesday', value)
    formMethods.setValue('openingHours.thursday', value)
    formMethods.setValue('openingHours.friday', value)
    formMethods.setValue('openingHours.saturday', value)
    formMethods.setValue('openingHours.sunday', value)
  }

  return (
    <Button
      onClick={setHours}
      sx={{ maxWidth: '100px', maxHeight: '40px', margin: '0' }}
      disabled={disabled}
    >
      APPLY TO ALL
    </Button>
  )
}

export default ApplyToAll
